import { Component, OnInit } from '@angular/core';
import { AppConstant } from './app.constants'; 
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private _configuration: AppConstant,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) { }
  title = 'Authentix-IQP-Web';

  ngOnInit() {
  };
}
